import React, { FunctionComponent } from 'react'

import { CSSObject } from 'styled-components'
import styled from 'styled-components/native'

import { SUPPORTED_FONT_FAMILY } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/fontFamilyMetadata'

import { BodyTextSize, FONT_FAMILY_AND_WEIGHT, getSupportedFontStyling } from '../../styles/typeStyles'
import { tID } from '../../utils/utils'
import { BodyText } from '../bodyText/BodyText'

const ReadOnlyFieldContainer = styled.View<{ styles?: Dict }>(({ styles = {} }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  ...styles,
}))

const LabelText = styled(BodyText)<{ customStyle?: CSSObject }>(({ customStyle = {} }) => {
  const regularFontStyling = getSupportedFontStyling(SUPPORTED_FONT_FAMILY.MODERAT, FONT_FAMILY_AND_WEIGHT.REGULAR)
  return {
    marginBottom: 8,
    ...regularFontStyling,
    ...customStyle,
  }
})

const ValueText = styled(BodyText)<{ customStyle?: CSSObject }>(({ customStyle = {} }) => {
  const lightFontStyling = getSupportedFontStyling(SUPPORTED_FONT_FAMILY.MODERAT, FONT_FAMILY_AND_WEIGHT.LIGHT)
  return {
    ...lightFontStyling,
    ...customStyle,
  }
})

export interface ReadOnlyFieldProps {
  label?: string
  value?: string
  testId?: string
  baseInputStyle?: CSSObject
  labelStyle?: CSSObject
  valueStyle?: CSSObject
}

export const ReadOnlyField: FunctionComponent<ReadOnlyFieldProps> = ({
  label,
  value,
  baseInputStyle,
  labelStyle,
  valueStyle,
  testId = 'ReadOnlyField',
}) => {
  return (
    <ReadOnlyFieldContainer testID={testId} styles={baseInputStyle}>
      <LabelText
        text={label}
        size={BodyTextSize.DEFAULT}
        customStyle={labelStyle}
        testID={tID('ReadOnlyField-label')}
      />
      <ValueText
        text={value}
        size={BodyTextSize.DEFAULT}
        customStyle={valueStyle}
        testID={tID('ReadOnlyField-value')}
      />
    </ReadOnlyFieldContainer>
  )
}
